import { render, staticRenderFns } from "./SymbolInTable.html?vue&type=template&id=60079912&scoped=true&"
import script from "./SymbolInTable.js?vue&type=script&lang=js&"
export * from "./SymbolInTable.js?vue&type=script&lang=js&"
import style0 from "./SymbolInTable.scss?vue&type=style&index=0&id=60079912&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60079912",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
